import { render, staticRenderFns } from "./ReturnFeeGuide.vue?vue&type=template&id=4a8bc8b3&scoped=true&"
import script from "./ReturnFeeGuide.vue?vue&type=script&lang=ts&"
export * from "./ReturnFeeGuide.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnFeeGuide.vue?vue&type=style&index=0&id=4a8bc8b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8bc8b3",
  null
  
)

export default component.exports